import React, { lazy } from "react";

const LazyAmbiguousExceptions = lazy(() => import("./AmbiguousExceptions"));

const AmbiguousExceptions = (
  props: JSX.IntrinsicAttributes & { children?: React.ReactNode }
) => <LazyAmbiguousExceptions {...props} />;

export default AmbiguousExceptions;
